import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthGuard } from '@/components/auth/AuthGuard'
import { LoginPage } from '@/pages/auth/LoginPage'
import { RegisterPage } from '@/pages/auth/RegisterPage'
import { ForgotPasswordPage } from '@/pages/auth/ForgotPasswordPage'
import { PerfilPage } from '@/pages/PerfilPage'
import { LoadingScreen } from '@/components/layout/LoadingScreen'
import { ErrorBoundary } from '@/components/ui/ErrorBoundary'

// ── Lazy loading por portal (code splitting automático pelo Vite) ──
// Cada portal só é carregado quando o usuário tem o role correspondente

const PortalRemitente      = lazy(() => import('@/portals/remitente/PortalRemitente'))
const PortalConductor      = lazy(() => import('@/portals/conductor/PortalConductor'))
const PortalTransportadora = lazy(() => import('@/portals/transportadora/PortalTransportadora'))
const PortalAdmin          = lazy(() => import('@/portals/operacional/PortalAdmin'))

export default function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          {/* ── Rotas públicas ────────────────────────────────── */}
          <Route path="/login"            element={<LoginPage />} />
          <Route path="/register"         element={<RegisterPage />} />
          <Route path="/forgot-password"  element={<ForgotPasswordPage />} />

          {/* ── Perfil (compartilhado entre portais) ─────────── */}
          <Route
            path="/perfil"
            element={
              <AuthGuard>
                <PerfilPage />
              </AuthGuard>
            }
          />

          {/* ── Portal Remitente ───────────────────────────────── */}
          <Route
            path="/r/*"
            element={
              <AuthGuard allowedRoles={['REMITENTE_ADMIN', 'REMITENTE_OPERATOR']}>
                <PortalRemitente />
              </AuthGuard>
            }
          />

          {/* ── Portal Conductor ───────────────────────────────── */}
          <Route
            path="/c/*"
            element={
              <AuthGuard allowedRoles={['CONDUCTOR_AUTONOMO', 'CONDUCTOR_VINCULADO']}>
                <PortalConductor />
              </AuthGuard>
            }
          />

          {/* ── Portal Transportadora ──────────────────────────── */}
          <Route
            path="/t/*"
            element={
              <AuthGuard allowedRoles={['TRANSPORTADORA_ADMIN', 'TRANSPORTADORA_OPERATOR']}>
                <PortalTransportadora />
              </AuthGuard>
            }
          />

          {/* ── Portal Admin RUTATEC ───────────────────────────── */}
          <Route
            path="/admin/*"
            element={
              <AuthGuard allowedRoles={['RUTATEC_ADMIN', 'RUTATEC_OPS']}>
                <PortalAdmin />
              </AuthGuard>
            }
          />

          {/* ── Redirect raiz ──────────────────────────────────── */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  )
}
